import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import BookingUpsellGroupName from "pages/Front/Booking/BookingUpsells/BookingUpsellGroupName";
import GroupedPackageUpsellItem from "pages/Front/Booking/components/PackageUpsell/GroupedPackageUpsellItem";
import PackageUpsellItem from "pages/Front/Booking/components/PackageUpsell/PackageUpsellItem";
import {GroupNameItem} from "utils/upsellsUtils";
import clsx from "clsx";

const UpsellGroupNameList = (props: {groupNameItems: GroupNameItem[]}) => {
    const {t} = useTranslation();
    if (props.groupNameItems.length == 0) {
        return <span>{t("No upsells available")}</span>;
    }
    return (
        <>
            {props.groupNameItems.map((groupNameItem, i) => {
                const groupNameVisible = groupNameItem.groupName !== "favorites";
                const [isOpen, setIsOpen] = useState(false);
                return (
                    <div className={"UpsellGroupNameList"} key={i}>
                        {groupNameVisible && <BookingUpsellGroupName groupNameItem={groupNameItem} isOpen={isOpen} setIsOpen={setIsOpen} />}
                        <div
                            className={clsx(
                                "UpsellGroupNameListContent",
                                groupNameVisible ? (isOpen ? "max-h-auto pt-4" : "max-h-0 pt-0") : "favorites_ungrouped mb-6 sm:mb-12",
                                "flex flex-col space-y-4 items-center justify-center w-full",
                                groupNameVisible && " overflow-hidden"
                            )}
                        >
                            {groupNameItem.items.map((item, index) =>
                                item.is_variant ? (
                                    <GroupedPackageUpsellItem key={index} item={item} />
                                ) : (
                                    <PackageUpsellItem key={index} isNewLayout={true} packageItem={item.items[0]} selectedPackage={null} />
                                )
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default UpsellGroupNameList;
